// extracted by mini-css-extract-plugin
export default {"wrapper":"dynamic_wrapper__qOCLG","key":"dynamic_key__mhYLb","value":"dynamic_value__+h9lY","card_wrapper":"dynamic_card_wrapper__xTt+A"};